// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contact_wrapper__1Zzf0","title":"Contact_title__z-qXk","links":"Contact_links__tVoh4","websiteLink":"Contact_websiteLink__2RMhn","social":"Contact_social__219QG"};